// example Layout.js
import React from "react";
import styled from "styled-components";
import { github } from "@code-surfer/themes";
import { theme as customTheme } from "../theme";

export const themes = [github, customTheme];

const Content = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;

  a {
    &:hover {
      text-decoration: none;
    }
  }
`;
const Footer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 20px;
  font-size: 0.8em;
`;

const Link = styled.a`
  color: rgb(227, 17, 108);
  text-decoration: none;

  &:hover {
    font-weight: 500;
  }
`;

export default ({ children }) => {
  return (
    <>
      <Content>{children}</Content>
      <Footer>
        <div>Emily Taylor</div>
        <Link href="https://twitter.com/_emilol">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            fill="rgb(0, 164, 219)"
            style={{ verticalAlign: "middle", height: "1em" }}
          >
            <path d="M30.063 7.313c-.813 1.125-1.75 2.125-2.875 2.938v.75c0 1.563-.188 3.125-.688 4.625a15.088 15.088 0 01-2.063 4.438c-.875 1.438-2 2.688-3.25 3.813a15.015 15.015 0 01-4.625 2.563c-1.813.688-3.75 1-5.75 1-3.25 0-6.188-.875-8.875-2.625.438.063.875.125 1.375.125 2.688 0 5.063-.875 7.188-2.5-1.25 0-2.375-.375-3.375-1.125s-1.688-1.688-2.063-2.875c.438.063.813.125 1.125.125.5 0 1-.063 1.5-.25-1.313-.25-2.438-.938-3.313-1.938a5.673 5.673 0 01-1.313-3.688v-.063c.813.438 1.688.688 2.625.688a5.228 5.228 0 01-1.875-2c-.5-.875-.688-1.813-.688-2.75 0-1.063.25-2.063.75-2.938 1.438 1.75 3.188 3.188 5.25 4.25s4.313 1.688 6.688 1.813a5.579 5.579 0 011.5-5.438c1.125-1.125 2.5-1.688 4.125-1.688s3.063.625 4.188 1.813a11.48 11.48 0 003.688-1.375c-.438 1.375-1.313 2.438-2.563 3.188 1.125-.125 2.188-.438 3.313-.875z"></path>
          </svg>
          @_emilol
        </Link>
      </Footer>
    </>
  );
};
